// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'description',
                    value: 'Description'
                },
                {
                    key: 'model',
                    value: 'Model'
                },
                {
                    key: 'account',
                    value: 'Responsible Dealer Account'
                },
                {
                    key: 'accountName',
                    value: 'Responsible Dealer Name'
                },
                {
                    key: 'location',
                    value: 'Responsible Dealer Location'
                },
                {
                    key: 'invoiceDate',
                    value: 'Invoice Date'
                },
                {
                    key: 'amountOfUse',
                    value: 'Current Amount of Use'
                },
                {
                    key: 'daysOnRent',
                    value: 'Accumulated Days on Rent'
                },
                {
                    key: 'currentlyOnRent',
                    value: 'Currently on Rent'
                },
                {
                    key: 'reportDate',
                    value: 'Report Date'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'reportDate',
                    order: 'DESC',
                    value: 'Report Date'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/state/views.js